import React from "react";
import ImprintAndPrivacy from "./ImprintAndPrivacy";

export default function Footer() {
    return (
        <footer className="card-footer App text-muted">
                <p>Copyright Ankit Chaudhary @ 2023. All rights reserved. <ImprintAndPrivacy>Impressum</ImprintAndPrivacy> </p>
        </footer>
    );
}